import * as React from 'react';
/**
 * @internal
 */

export const ThemeContext = /*#__PURE__*/React.createContext(undefined);
/**
 * @internal
 */

export const ThemeProvider = ThemeContext.Provider;
//# sourceMappingURL=ThemeContext.js.map